export class Evaluacion {
    evaluacionpendientecolaboradorid: number = 0;
    periodoevaluacionid: number = 0;
    periodoevaluacion: string = "";
    colaboradorevaluador: number = 0;
    usuarioevaluadorid: number = 0;
    departamentoevaluadorid: number = 0;
    puestoevaluadorid: number = 0;
    usuarioid: number = 0;
    puestoid: number = 0;
    nombre: string = "";
    colaboradorid: number = 0;
    colaboradorrelacionid: number = 0;
    departamento: string = "";
    puesto: string = "";
    urlfotografia: string = "";
    tipovisualizacioncompetenciacriterioid:number = 0;
    tipovisualizacionpreguntaid:number = 0;
    tipovisualizacionrespuestaid:number = 0;

    constructor(init?: Partial<Evaluacion>) {
        Object.assign(this, init);
    }
}